import { observer } from 'mobx-react-lite'
import { type ProfileViewModel } from '@/features/iam/users/ProfileViewModel'
import { SectionEmpty } from '@/features/iam/users/components/SectionEmpty'
import { SelectionListContainer } from '@/features/iam/users/components/SelectionList/SelectionListContainer'
import { Icon } from '@/components/Icon'
import { SelectionEditorDialog } from '@/features/iam/users/components/SelectionEditorDialog'

export interface SkillsContainerProps {
  vm: ProfileViewModel
}

export const SkillsContainer = observer(function SkillsContainer({
  vm,
}: SkillsContainerProps) {
  const createList = (editing: boolean) => (
    <SelectionListContainer
      selectionVm={vm.general.skillSelection}
      icon={<Icon name="skills" />}
      editing={editing}
      getContent={(item) => ({
        title: item.name,
        description: item.description,
      })}
    />
  )

  return (
    <>
      {vm.general.skillSelection.selectedItems.length === 0 ? (
        <SectionEmpty>
          You haven't added any skills yet — lets change that!
        </SectionEmpty>
      ) : (
        createList(false)
      )}
      <SelectionEditorDialog
        title="Manage your Skills"
        description={
          <>
            Select the skills that represent the type of requests you are
            comfortable with.
          </>
        }
        showing={vm.general.skillSelection.modal.showing}
        onClose={vm.general.skillSelection.modal.close}
      >
        {createList(true)}
      </SelectionEditorDialog>
    </>
  )
})
